export const doResearchOnlineRegex = /(do research|go online)/i;
export const makeACallRegex = /(create\s+an?\s+agent|create\s+a\s+bot)/i;
